export default __webpack_public_path__ + "static/media/36I-102636_-17089_0.de83b4fb.jpg";